import { css } from "@emotion/react";

export const layoutStyle = css`
  min-height: 100vh;
`;

export const siderStyle = css`
  min-height: 100vh;
`;

export const headerStyle = css`
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 64px;
  padding: 0 16px;
  background-color: #000000;
`;

export const headerRowStyle = css`
  height: 100%;
`;

export const headerLogoStyle = css`
  height: 36px;
  max-width: 100%;
  object-fit: contain;
  display: block;
`;

export const headerCollapseIconContainer = css`
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
`;

export const mobileContentStyle = css`
  padding-top: 64px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const drawerBodyStyle = {
  padding: 0,
  backgroundColor: "#202020",
};

export const drawerHeaderStyle = {
  display: "none",
};
